import styled from 'styled-components';

export const MergeGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.8;
  }

  select {
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #d5dbe7;
    font-size: 13px;
    background: #f9fbff;
    transition: all 0.2s ease;
    cursor: pointer;

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.blue700};
      box-shadow: 0 0 0 2px rgba(76, 139, 245, 0.15);
    }

    &:hover {
      background: #f4f8ff;
    }
  }
`;

export const ApplyButton = styled.button`
  width: 100%;
  padding: 9px 12px;
  border-radius: 8px;
  border: 0;
  background: ${({ theme }) => theme.colors.blue700 || '#2f6feb'};
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.92;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;